const TOKEN_KEY = 'eagle_token';

export const AUTH_TOKEN_CHANGED_EVENT = 'eagle:auth-token-changed';

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
  window.dispatchEvent(new CustomEvent(AUTH_TOKEN_CHANGED_EVENT));
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  window.dispatchEvent(new CustomEvent(AUTH_TOKEN_CHANGED_EVENT));
};

export const isAuthenticated = () => {
  return !!getToken();
};



